import { render, staticRenderFns } from "./CourseEditSlidebar.vue?vue&type=template&id=7ee942a0"
import script from "./CourseEditSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseEditSlidebar.vue?vue&type=script&lang=js"
import style0 from "./CourseEditSlidebar.vue?vue&type=style&index=0&id=7ee942a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports